<template>
	<hr/>
<div class="footer px-4 mb-2 pt-1">
	<div class="col-md-12 footer-left">
		<h2 style="text-align: center;"><router-link  :to="{name:'Home'}" style="color:red;font-family: adera;">RADAP</router-link></h2>
				<!-- <h2 style="text-align: right;"><router-link  :to="{name:'Home'}" style="color:red;"><strong style="font-family: adera;">RADAP</strong>راداَپ</router-link></h2> -->

		<p style="color:black" class="m-0">با راداَپ ضمن تهیه مایحتاج روزانت با قیمت مناسب و ارسال سریع درآمد هم داشته باش.</p>
	</div>
	<div class="footer-column mt-2">
		<div class="footer-item my-0">
			<div class="w3-address">
				<div>
					<div>
						<small class="text-dark"><img src="https://radap.ir/imagesUploaded/other/support.png" width="16" height="16" class="pe-1"/>شماره پشتیبانی</small>
						<p><a class="text-primary" href="tel:05152524850" target="_blank">٥٢٥٢٤٨٥٠<span class="d-inline-block">-٠٥١</span></a></p>
					</div>
				</div>
				<div>
					<div>
						<small class="text-dark"><img src="https://radap.ir/imagesUploaded/other/phone-call.png" width="16" height="16" class="pe-1"/>شماره همراه</small>
						<p ><a class="text-primary" href="tel:09928728971" target="_blank">٠٩٩٢٨٧٢٨٩٧١</a></p>
						<p class="mt-0"><a class="text-primary" href="tel:09903573351" target="_blank">٠٩٩٠٣٥٧٣٣٥١</a></p>
					</div>
				</div>
				<div>
					<div>
						<small class="text-dark"><img src="https://radap.ir/imagesUploaded/other/email.png" width="16" height="16" class="pe-1"/>ایمیل</small>
						<p><a  class="text-primary" href="info.radap@gmail.com" style="word-wrap: break-word;">info.radap@gmail.com</a></p>
					</div>
				</div>
			</div>
	
		</div>
		<div class="footer-item sign-gd center-access my-0">
			<!-- <h4  class="text-dark">دسترسی سریع</h4> -->
			<ul>
				<li><img src="https://radap.ir/imagesUploaded/other/home.png" width="16" height="16" class="pe-1"/><router-link  :to="{name:'Home'}">خانه</router-link></li>
				<li><img src="https://radap.ir/imagesUploaded/other/group.png" width="16" height="16" class="pe-1"/><router-link  :to="{name:'About'}">درباره ما</router-link></li>
				<li><img src="https://radap.ir/imagesUploaded/other/phone-call.png" width="16" height="16" class="pe-1"/><router-link  :to="{name:'Contact'}">تماس با ما</router-link></li>
				<li><img src="https://radap.ir/imagesUploaded/other/money-stack.png" width="16" height="16" class="pe-1"/><router-link  :to="{name:'Benefit'}">کسب درآمد</router-link></li>
				<li><img src="https://radap.ir/imagesUploaded/other/terms-and-conditions.png" width="16" height="16" class="pe-1"/><router-link  :to="{name:'Rulls'}">قوانین و مقررات</router-link></li>
				<li><img src="https://radap.ir/imagesUploaded/other/fast-delivery.png" width="16" height="16" class="pe-1"/><a href="https://safir.radap.ir">ثبت نام رانندگان</a></li>
			</ul>
		</div>
	</div>
	<div class="w3-address-grid">
		<div class="w3-address-right text-justify w-100">
			<h6 style="color:black"><img src="https://radap.ir/imagesUploaded/other/building.png" width="16" height="16" class="pe-1"/>نشانی</h6>
			<p  style="color:black">
				استان خراسان رضوی، شهرستان تربت جام،محله: شهرک آزادگان، معبر ماقبل آخر: کوچه شهید عباسپور ١٣ (انصار ١٠ )، معبر آخر: خیابان آزادگان  شهید عباسپور ١٥  پلاک ٠،ساختمان دفتر سفارش آنلاین راداَپ وحید سعیدی راد، طبقه همکف 
				<br />
				کد پستی : ٩٥٧١٧٤٤٤٣٥ 
			</p>
		</div>
	</div>
	<div>
		<a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=320518&Code=wGKOsDuxyBO7O85Dkj58' >
			<img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=320518&Code=wGKOsDuxyBO7O85Dkj58' alt='' style='cursor:pointer' Code='wGKOsDuxyBO7O85Dkj58'>
		</a>
		<p class="copy-right">کلیه حقوق مادی و معنوی این سایت متعلق به برند راداَپ با نام تجاری تجارت الکترونیک راد جام میباشد،</p>
		<p class="copy-right" style="margin-top:0 !important"> حق copyright@ محفوظ است.</p>
	</div>
</div>
</template>

<style scoped>
*{
	letter-spacing: normal !important;
	font-family: IranSans;
}
.dir-rtl{
    direction: rtl;
    text-align: right;
}
.fl-right{
    float: right;
}
.social-nav {
    display: flex;
}
.footer-column{
	display: flex;
}
.footer-item{
	width: 50%;
}
/* @media (max-width:667px){
	.footer-column{
		flex-direction: column;
	}
	.footer-item{
		width: 100%;
	}
} */
.footer{
	background-color: rgb(238 241 249);
}
p{
	margin: 0;
}
</style>